export const FAIR_PLAY_LINK = 'https://hc.cian.ru/hc/ru/articles/360061362792';
export const IDENTIFICATION_LINK = 'https://my.cian.ru/identification?type=document';
